var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.address
      ? _c(
          "div",
          [
            !!_vm.name
              ? _c(
                  "p",
                  {
                    staticStyle: { "font-size": "16px", "margin-bottom": "0" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !!_vm.poBox
              ? _c(
                  "p",
                  {
                    staticStyle: { "font-size": "16px", "margin-bottom": "0" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.poBox) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !!_vm.street
              ? _c(
                  "p",
                  {
                    staticStyle: { "font-size": "16px", "margin-bottom": "0" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.street) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !!_vm.street2
              ? _c(
                  "p",
                  {
                    staticStyle: { "font-size": "16px", "margin-bottom": "0" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.street2) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !!_vm.street3
              ? _c(
                  "p",
                  {
                    staticStyle: { "font-size": "16px", "margin-bottom": "0" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.street3) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !!_vm.street4
              ? _c(
                  "p",
                  {
                    staticStyle: { "font-size": "16px", "margin-bottom": "0" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.street4) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { "font-size": "16px", "margin-bottom": "0" } },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.zip) +
                    " " +
                    _vm._s(_vm.city) +
                    "\n    "
                )
              ]
            ),
            _vm._v(" "),
            !!_vm.country
              ? _c(
                  "p",
                  {
                    staticStyle: { "font-size": "16px", "margin-bottom": "0" }
                  },
                  [_vm._v("\n      " + _vm._s(_vm.country) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.address && _vm.showMap
              ? _c("MapModal", { attrs: { value: _vm.address } })
              : _vm._e()
          ],
          1
        )
      : _c("p", [_vm._v("-")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43c5b3f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c5b3f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Address.vue
// module id = null
// module chunks = 